import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import { Tooltip } from "@mui/material";
import Button from "@mui/material/Button";
import { useConfigurationStatus } from "@plansoft-configuration-renderer/components";
import { ConfigurationObjectResult } from "@plansoft-configuration-renderer/configuration-api";
import { Gateway } from "@plansoft-configuration-renderer/gateway";

import { useSubstructureStandaloneContentCtx } from "@/renderer/SubstructureStandaloneContentCtx";
import { useBomContext } from "@/renderer/controls/BillOfMaterials/BomContext";

export function ShowBOMButton({
  substructure,
}: {
  substructure: ConfigurationObjectResult;
}): JSX.Element {
  const { t } = useTranslation();
  const { setSelectedSubstructure, selectedSubstructure } =
    useSubstructureStandaloneContentCtx();
  const { setIsBomOpen } = useBomContext();

  const currentSubstructure = selectedSubstructure?.guid === substructure.guid;

  const { isComplete } = useConfigurationStatus(substructure);

  function handleClick(): void {
    setSelectedSubstructure(null);
    setIsBomOpen(true);
  }

  return (
    <>
      {currentSubstructure && (
        <Gateway into="show_BOM_Button">
          <Tooltip
            title={
              !isComplete ? t("regiolux:button.showBOM.disabledTooltip") : ""
            }
          >
            <span>
              <Button onClick={handleClick} disabled={!isComplete}>
                {t("regiolux:button.showBOM.label")}
              </Button>
            </span>
          </Tooltip>
        </Gateway>
      )}
    </>
  );
}
